import * as l from "react";
const v = (e) => /* @__PURE__ */ l.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ l.createElement(
    "mask",
    {
      id: "BY_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ l.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ l.createElement("g", { mask: "url(#BY_svg__a)" }, /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0h32v24H0V0z",
      fill: "#73BE4A"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v16h32V0H0z",
      fill: "#AF0100"
    }
  ), /* @__PURE__ */ l.createElement("path", { fill: "#F7FCFF", d: "M0 0h6v24H0z" }), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M.443 2.236L1.896.056l1.415 2.18-1.415 2.08-1.453-2.08zm1.447 1.19l.815-1.197L1.89.976l-.835 1.253.835 1.197zM2 2.064h-.25v.517H2v-.517zM1.136 4.186l-.693.99.693.946.675-.946-.675-.99zm.324 1.007l-.312.424-.316-.449.315-.465.313.49zM2.636 4.186l-.693.99.693.946.675-.946-.675-.99zm.324 1.007l-.312.424-.316-.449.315-.465.313.49z",
      fill: "#B20000"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.636 4.186l-.693.99.693.946.675-.946-.675-.99zm.324 1.007l-.312.424-.316-.449.315-.465.313.49zM5.136 4.186l-.693.99.693.946.675-.946-.675-.99zm.324 1.007l-.312.424-.316-.449.315-.465.313.49zM2.943 2.236L4.396.056l1.415 2.18-1.415 2.08-1.453-2.08zm1.447 1.19l.815-1.197L4.39.976l-.835 1.253.835 1.197zm.11-1.362h-.25v.517h.25v-.517z",
      fill: "#B20000"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M1.656 12.406L.037 9.687l.426-.27 1.174 1.97 1.432-2.631 1.468 2.638 1.037-1.721.425.272-1.48 2.455-1.445-2.6-1.418 2.606z",
      fill: "#B20000"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M.75.517h.269v.516H.75V.517zM3 0h.269v.516H3V0zM5.25.517h.269v.516H5.25V.517zM.75 3.613H1v.516H.75v-.516zm2.25 0h.25v.516H3v-.516zm2.5 0h-.25v.516h.25v-.516zM.75 6.193H1v.516H.75v-.516zm2.25 0h.25v.516H3v-.516zm2.5 0h-.25v.516h.25v-.516z",
      fill: "#B20000"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.208 8.954l-.664.969L.496 8.036l1.38-2.156 1.186 1.88L4.25 5.88l1.38 2.156L4.58 9.923l-.664-.969.524-1.09-.192-.443-1.12 1.817v.215l-.067-.107-.066.107v-.215l-1.12-1.817-.192.443.524 1.09zM3 10.581h.25v.516H3v-.516zm0 2.581h.25v.516H3v-.516zm0-1.807h-.25v.516H3v.259h-.25v.516H3v-.259h.25v.259h.25v-.516h-.25v-.259h.25v-.516h-.25v.516H3v-.516zm-.75.516h.25v.516h-.25v-.516zm1.75 0h-.25v.516H4v-.516zm-3.5 0h.25v.516H.5v-.516zm5.25 0H5.5v.516h.25v-.516zM.443 21.764l1.453 2.18 1.415-2.18-1.415-2.08-1.453 2.08zm1.447-1.19l.815 1.197-.815 1.253-.835-1.253.835-1.197zM2 21.936h-.25v-.516H2v.517zM1.136 19.814l-.693-.99.693-.946.675.946-.675.99zm.324-1.008l-.312-.423-.316.449.315.465.313-.49zM2.636 19.814l-.693-.99.693-.946.675.946-.675.99zm.324-1.008l-.312-.423-.316.449.315.465.313-.49z",
      fill: "#B20000"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.636 19.814l-.693-.99.693-.946.675.946-.675.99zm.324-1.008l-.312-.423-.316.449.315.465.313-.49zM5.136 19.814l-.693-.99.693-.946.675.946-.675.99zm.324-1.008l-.312-.423-.316.449.315.465.313-.49zM2.943 21.764l1.453 2.18 1.415-2.18-1.415-2.08-1.453 2.08zm1.447-1.19l.815 1.197-.815 1.253-.835-1.253.835-1.197zm.11 1.361h-.25v-.516h.25v.517z",
      fill: "#B20000"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M1.656 11.594L.037 14.313l.426.27 1.174-1.97 1.432 2.631 1.468-2.638 1.037 1.721.425-.272-1.48-2.455-1.445 2.6-1.418-2.606z",
      fill: "#B20000"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M.75 23.483h.269v-.516H.75v.516zM3 24h.269v-.516H3V24zM5.25 23.483h.269v-.516H5.25v.516zM.75 20.387H1v-.516H.75v.516zm2.25 0h.25v-.516H3v.516zm2.5 0h-.25v-.516h.25v.516zM.75 17.807H1v-.516H.75v.516zm2.25 0h.25v-.516H3v.516zm2.5 0h-.25v-.516h.25v.516z",
      fill: "#B20000"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.208 15.193l-.664-.968-1.048 1.887 1.38 2.156 1.186-1.88 1.187 1.88 1.38-2.156-1.048-1.887-.664.968.524 1.09-.192.443-1.12-1.817v-.215l-.067.108-.066-.108v.215l-1.12 1.817-.192-.443.524-1.09z",
      fill: "#B20000"
    }
  ))
);
export {
  v as default
};
